var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotifMoveTrust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 127,
    viewBox: "0 0 65 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 -17L27.957 16.5252V100.141L130 66.6158V-17Z",
    fill: "#F2FFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.022 9.49805L13.9785 43.0232V126.639L116.022 93.1138V9.49805Z",
    fill: "#F2FFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.043 35.9961L1.80006e-05 69.5213V153.137L102.043 119.612V35.9961Z",
    fill: "#F2FFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 -7L37.957 26.5252V110.141L140 76.6158V-7Z",
    fill: "#DCFFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.022 19.498L23.9785 53.0232V136.639L126.022 103.114V19.498Z",
    fill: "#DCFFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.043 45.9961L10 79.5213V163.137L112.043 129.612V45.9961Z",
    fill: "#DCFFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 3L47.957 36.5252V120.141L150 86.6158V3Z",
    fill: "#F0FFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.022 29.498L33.9785 63.0232V146.639L136.022 113.114V29.498Z",
    fill: "#F0FFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.043 55.9961L20 89.5213V173.137L122.043 139.612V55.9961Z",
    fill: "#F0FFE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 173,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotifMoveTrust);
export default __webpack_public_path__ + "static/media/motif-move-trust.824530c94fb2b6c599d702544ecf1aa2.svg";
export { ForwardRef as ReactComponent };